<mat-card>
  <mc-loader *ngIf="loadingState.loading$ | async"></mc-loader>

  <div class="mat-card-header">
    <mc-auth-card-header></mc-auth-card-header>
  </div>

  <mat-card-content>
    <p class="mc-form-title text-x-large" i18n="The license url form heading for inputting a license url">Enter your license vanity to log in</p>
    <form #urlForm="ngForm" novalidate [ngFormOptions]="{ updateOn: 'submit' }" (ngSubmit)="onSubmit(urlForm)">
      <mat-form-field appearance="standard" class="mc-form-field" color="secondary" floatLabel="always" [hideRequiredMarker]="true">
        <input matInput type="text" [(ngModel)]="vanity" name="vanity" placeholder="your-vanity" i18n-placeholder="The placeholder for the license url vanity field" required autofocus>
        <span matSuffix class="text-heavy-weight">.{{ portalRootDomain }}</span>
        <mat-error i18n="The license url field is required error message">URL vanity is required</mat-error>
      </mat-form-field>

      <mc-error-code-expansion-panel *ngIf="loadingState.generalError$ | async as generalErrorCode" compact [generalErrorCode]="generalErrorCode" [detailedErrorCodes]="loadingState.detailedErrors$ | async" class="mc-error-message"></mc-error-code-expansion-panel>

      <button mat-raised-button class="mc-license-url-card-continue-button" color="primary" type="submit" i18n="The continue button to validate and redirect to the license login page">Continue</button>
    </form>

    <div class="mc-form-spacer"></div>
    <div class="mc-form-spacer"></div>
    <a class="mc-license-url-card-login-button" [routerLink]="loginRouteCommands$ | async" i18n="The login link">Log in with your email address</a>
  </mat-card-content>
</mat-card>